export default {
  partnerBuy: { method: 'post', url: '/partnerBuyRecord/partnerBuy' } // 购买合伙人，获取链上参数
}
